import { IQueryTypeFragments } from '../../QueryFragments';
import { QueryType } from '../Default';

const skuSmooshImagesFragment = `
    on ${QueryType.skus} {
        media {
            smoosh {
                src
                alt
            }
        }
    }
`;

export const skuSmooshImagesFragments = (): IQueryTypeFragments => {
    return {
        [QueryType.skus]: skuSmooshImagesFragment
    };
};
